import { FilterMinusIcon } from './FilterMinusIcon';

/**
 * author: GreenTurtwig
 * id BCA7EE0A-BADF-441A-B660-C37C0DFEF83A
 * name filter-minus
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-minus.svg
 * tags
 */
export const FunnelMinusIcon = FilterMinusIcon;
export default FunnelMinusIcon